import { render } from "./QuestionHeader.vue?vue&type=template&id=df3cbb0c&ts=true"
import script from "./QuestionHeader.vue?vue&type=script&lang=ts"
export * from "./QuestionHeader.vue?vue&type=script&lang=ts"

import "./QuestionHeader.vue?vue&type=style&index=0&id=df3cbb0c&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__